import { CircleImage, Props } from '@components/CircleImage/Original'
import { FontAwesomeIcon, findIconDefinition } from '@purposity/icons'
import { altWhite, neutralGray, textGray } from '@themes/Colors'
import * as React from 'react'
import { Text, View } from 'react-native'
import { useAuthContext } from '~/features/auth/components/AuthProvider'

export const ProfilePic = ({ size = 96, ...props }: Props) => {
  const { user } = useAuthContext()

  if (user?.imageUrl) {
    return (
      <View
        style={{
          backgroundColor: props.hideBorder ? undefined : neutralGray,
          width: size,
          height: size,
          borderRadius: size / 2,
        }}
      >
        <CircleImage size={size} image={user?.imageUrl} {...props} />
      </View>
    )
  }
  return (
    <View
      style={{
        backgroundColor: altWhite,
        height: size,
        width: size,
        borderRadius: size / 2,
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 1,
        borderColor: neutralGray,
      }}
    >
      <Text style={{ fontSize: size / 2 }}>
        <FontAwesomeIcon
          icon={findIconDefinition({ prefix: 'fas', iconName: 'user' })}
          color={textGray}
          style={{ alignItems: 'center' }}
        />
      </Text>
    </View>
  )
}
